export enum RhapsodyGoPaymentMethod {
  CREDIT_CARD = 'Credit card',
  ELECTRONIC_CHECK = 'Electronic check',
}
